import Vue from 'vue'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'
import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';


import App from './App.vue'
import './registerServiceWorker'
import "./css/styles.less"

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, {tapTolerance: 15, 
	touchHoldTolerance: 600,
    swipeTolerance: 100,
    longTapTimeInterval: 600,
	touchClass: 'wf-touch'
});

Vue.config.productionTip = false

const WF_MAP_TYPE = "2d";
const WF_PROJECT = "f7250a8a12f618041b11cf6b0ecbc251";
const WF_API = "live";

const store = new Vuex.Store({
  state: {
    appName: "Wayfinder Vue Components",
    currentPOI: null,
    currentGroup: null,
    searchVisible: false,
  },
  mutations: {
    setPOI (state, poi) {
      state.currentPOI = poi;
    },
    setGroup (state, group ) {
      state.currentGroup = group;
    },
    showSarch (state, show) {
      state.searchVisible = show;
    }
  },
  actions: {
		setPOI : (context, poi) => {
			context.commit('setPOI',  Object.freeze(poi));
		},
    setGroup : (context, group) => {
			context.commit('setGroup',  Object.freeze(group));
		},
    SHOW_SEARCH : (context, show) => {
			context.commit('showSarch',  show);
		},
  }
})

loadWayfinder(WF_MAP_TYPE, WF_API, loadVue);

function loadVue () {
	new Vue({
		store,
		render: h => h(App),
		created () {
			Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
		}
	}).$mount('#app')
}
